import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib';
import { createSlice } from '@reduxjs/toolkit';

export const preferencesUiSlice = createSlice({
  name: 'preferences-ui',
  initialState: baseUiInitialState,
  reducers: baseUiReducers,
});
